import React, { useEffect, useState } from "react";

import PageHead from "../Head";
import { Provider } from "react-redux";
import Context, { useAppContext } from "@/context/Context";
import Store from "@/redux/store";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import Pagination from "@/components/Common/Pagination";
import { BaseApiService } from "@/utils/BaseApiService";
import { isNotEmpty } from "@/utils/Utils";
import Link from "next/link";
import CourseFilter from "@/components/Category/Filter/CourseFilter";
import CategoryBanner from "@/components/Category/Category-Banner";
import { useRouter } from "next/router";
import StorageParams from "@/constants/StorageParams";

const CoursesPage = () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [courses, setCourses] = useState([]);
  const [totalCourses, setTotalCourses] = useState(0);


  const router = useRouter();

  const fetchCourses = async (categoryId) => {
    let categorySearchParameters = {
      searchTerm: "",
      offset: 0,
      limit: 0,
      categoryId: categoryId || null,  // Include categoryId in the search
    };

    let searchParameters = {
      searchTerm: "",
      offset: 0,
      limit: 0
    };

    try {
      const response = await new BaseApiService("/courses").getRequestWithJsonResponse(
        categoryId ? categorySearchParameters : searchParameters
      );
      console.log("Category ", categoryId);
      console.log("Course Response:", response);
      console.log("Total Records:", response?.totalItems);
      if (response && response.records) {
        setCourses(response.records);
        setTotalCourses(response?.totalItems);
      } else {
        console.error("Unexpected response structure:", response);
      }
    } catch (error) {
      console.error("fetchCourses:fetchDataFromServer>>>>", error);
    }
  };

  const startIndex = (page - 1) * 15;
  const getSelectedCourse = courses.slice(startIndex, startIndex + 15);

  const handleClick = (num) => {
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // Fetch courses when the category query parameter changes
    const categoryId = router.query.category || null;
    fetchCourses(categoryId);
  }, [router.query.category]);

  useEffect(() => {
    setTotalPages(Math.ceil(courses.length / 15));
  }, [courses]);

  return (
    <>
      <PageHead title="Course Filter One Open - Online Courses & Education NEXTJS14 Template" />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />

          <CategoryHead categoryId={router.query.category || null} totalCourses={totalCourses} />
          <div className="rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="inner">
              <div className="container">
                <CourseCard course={getSelectedCourse} />

                {courses.length > 15 ? (
                  <div className="row">
                    <div className="col-lg-12 mt--60">
                      <Pagination
                        totalPages={totalPages}
                        pageNumber={page}
                        handleClick={handleClick}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <Separator />
          <FooterOne bgColor="bg-color-darker" />
        </Context>
      </Provider>
    </>
  );
};

const CategoryHead = ({ categoryId, totalCourses }) => {
  const router = useRouter();
  const [activeTab, setActiveTab] = useState("All Course");

  const handleButtonClick = (categoryId) => {
    // Update the URL with the selected category ID
    router.push({
      pathname: '/courses',
      query: { category: categoryId },
    });
    setActiveTab(categoryId);
  };

  console.log("Course head total records ", totalCourses);

  return (
    <>
      <div className="rbt-page-banner-wrapper">
        <div className="rbt-banner-image"></div>

        <div className="rbt-banner-content">
          {categoryId ? (
            <CategoryBanner categoryId={categoryId} totalCourses={totalCourses} />
          ) : (
            <CategoryBanner totalCourses={totalCourses} />
          )}
        </div>
      </div>
    </>
  );
};


const CourseCard = ({ course, start, end }) => {
  const { toggle } = useAppContext();
  const [courses, setCourse] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loggedIn, setLoggenIn] = useState(false);
  const router = useRouter();

  const startIndex = (page - 1) * 15;

  const getSelectedCourse = courses.slice(startIndex, startIndex + 15);

  const handleClick = (num) => {
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const addToWishList = async (courseId) => {
    if (!confirm("Are you sure you want to add this course to your wishlist?")) return; // Confirmation before deleting

    if (!loggedIn) {
      router.push('/login');
      return;
    }

    try {
      const response = await new BaseApiService(`/wishlist/add/${courseId}`)
        .postRequestWithJsonResponse({});
      console.log('Course added successfully:', response);
      if (response.status === 'Success') {
        alert('Course added successfully!');
      }
    } catch (error) {
      console.error('An error occurred:', error);
      alert("An error occurred while adding course to wishlist. Please try again.");
    }
  };


  useEffect(() => {
    setCourse(course);
    const isLoggedIn = localStorage.getItem(StorageParams.IS_LOGGED_IN) === "true";
    setLoggenIn(isLoggedIn);
    setTotalPages(Math.ceil(course.length / 15));
  }, [setTotalPages, setCourse, getSelectedCourse]);


  return (
    <>
      <div
        className={`rbt-course-grid-column ${!toggle ? "active-list-view" : ""
          }`}
      >
        {course.slice(start, end).map((data, index) => (
          <div className="course-grid-3" key={index}>
            <div
              className={`rbt-card variation-01 rbt-hover ${!toggle ? "card-list-2" : ""
                }`}
            >
              <div className="rbt-card-img">
                <Link href={`/course-details/${data.id}`}>
                  <img src={isNotEmpty(data.coverImageUrl)
                    ? data.coverImageUrl
                    : "https://res.cloudinary.com/revival-gateway/image/upload/v1687342256/courses/lessons/297e018288dd4b820188dd6c19400005.jpg"
                  } alt="Card image" width={355} height={244} style={{ width: 355, height: 200 }} />
                </Link>
              </div>
              <div className="rbt-card-body">
                <div className="rbt-card-top">
                  <div className="rbt-review">
                    <div className="rating">
                      {[...Array(5)].map((_, index) => {
                        const ratingValue = index + 1;
                        return (
                          <i
                            key={index}
                            className={
                              ratingValue <= Math.floor(data?.averageRating)
                                ? "fas fa-star"
                                : ratingValue === Math.ceil(data?.averageRating) && !Number.isInteger(data?.averageRating)
                                  ? "fas fa-star-half-alt"
                                  : "far fa-star"
                            }
                          ></i>
                        );
                      })}
                    </div>
                    <span className="rating-count">
                      ({data.ratingsCount} Reviews)
                    </span>
                  </div>
                  <div className="rbt-bookmark-btn">
                    <a
                      href="#"
                      className="rbt-round-btn"
                      title="Add to Wishlist"
                      onClick={() => addToWishList(data.id)}
                    >
                      <i className="feather-bookmark pl--0"></i>
                    </a>
                  </div>
                </div>

                <h4 className="rbt-card-title">
                  <Link href={`/course-details/${data.id}`}>
                    {data.title}
                  </Link>
                </h4>

                <ul className="rbt-meta">
                  <li>
                    <i className="feather-book"></i>
                    {data.numberOfLessons} Lessons
                  </li>
                  <li>
                    <i className="feather-users"></i>
                    {data.numberOfLessons} Students
                  </li>
                </ul>

                <p className="rbt-card-text" style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>{data.description}</p>
                <div className="rbt-author-meta mb--10">
                  <div className="rbt-avater">
                    <Link href="#">
                      <img src={data?.instructor?.imageUrl} alt={data?.instructor?.fullName} width={355} height={244} />
                    </Link>
                  </div>
                  <div className="rbt-author-info">
                    By <Link href={`/profile/${data.id}`}>{data?.instructor?.fullName}</Link>{" "}
                    In <Link href="#">{data?.category?.name}</Link>
                  </div>
                </div>
                <div className="rbt-card-bottom">
                  {
                    data.isPaid ?
                      <div className="rbt-price">
                        <span className="current-price">${data.discountedPrice}</span>
                        <span className="off-price">${data.price}</span>
                      </div> :
                      <div className="rbt-price">
                        <span className="current-price">${data.discountedPrice}</span>
                        <span className="off-price">${data.price}</span>
                      </div>
                  }
                  <Link
                    className="rbt-btn-link"
                    href={`/course-details/${data.id}`}
                  >
                    Learn More<i className="feather-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* {course.length > 6 ? (
        <div className="row">
          <div className="col-lg-12 mt--60">
            <Pagination
              totalPages={totalPages}
              pageNumber={page}
              handleClick={handleClick}
            />
          </div>
        </div>
      ) : (
        ""
      )} */}
    </>
  );
};

const styles = {
  truncateText: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }
};

export default CoursesPage;